<template><section><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">h5</span>&gt;</span>Enter your email, we will send you product menu<span class="hljs-tag">&lt;/<span class="hljs-name">h5</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">input</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"text"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"form-control"</span>
      <span class="hljs-attr">@keyup.enter</span>=<span class="hljs-string">"$emit('commitAccept')"</span>
      <span class="hljs-attr">v-model</span>=<span class="hljs-string">"localData"</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="actionscript">
export <span class="hljs-keyword">default</span> {
  props: {
    data: {
      <span class="hljs-keyword">default</span>: <span class="hljs-literal">null</span>,
    },
  },
  data() {
    <span class="hljs-keyword">return</span> {
      localData: <span class="hljs-literal">null</span>,
    }
  },
  watch: {
    localData(value) {
      <span class="hljs-keyword">this</span>.$emit(<span class="hljs-string">'updateData'</span>, value)
    },
    data(value) {
      <span class="hljs-keyword">this</span>.localData = value
    },
  },
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</section></template>

<script>
export default {
  props: {
    data: {
      default: null,
    },
  },
  data() {
    return {
      localData: null,
    }
  },
  watch: {
    localData(value) {
      this.$emit('updateData', value)
    },
    data(value) {
      this.localData = value
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/Resource/Example/CustomeComponent/FormComponent.vue